import axios from "axios";
import axios2 from "@/axios";

const state = {
  orders: [],
  orderProducts: [],
  orderTickets: [],
};

const getters = {
  retrieveUnpaidOrders: (state) => {
    if (state.orders.length) {
      return state.orders.filter((order) => order.locked == 1);
    }
  },
  retrieveAllOrders: (state) => {
    if (state.orders.length) {
      return state.orders;
    }
  },
  retrieveAllOrdersTickets: (state) => {
    if (state.orders.length) {
      let tickets = [];
      state.orders.forEach((order) => {
        tickets.push(Object.values(order.tickets));
      });
      return tickets.reduce((acc, currVal) => acc.concat(currVal), []);
    }
  },
  retrieveInvoiceSummary: (state) => {
    if (state.orderProducts.length) {
      let totalPacks = 0;
      let totalBoxes = 0;
      let totalKilo = 0;
      let totalEs = 0;
      let totalVal = 0;
      state.orderProducts.forEach((prod) => {
        if (prod["quantity_type"] == "K") {
          totalKilo += parseFloat(prod["quantity_ordered"]);
          totalPacks++;
        } else if (prod["quantity_type"] == "E") {
          totalEs += parseFloat(prod["quantity_ordered"]);
          totalPacks++;
        } else {
          totalBoxes += parseFloat(prod["quantity_ordered"]);
          totalPacks += parseFloat(prod["quantity_ordered"]);
        }

        totalVal +=
          parseFloat(prod["item_value"]) + parseFloat(prod["vat_value"]);
      });
      if (totalVal <= 0) {
        totalVal = 0
      }
      return {
        totalPackages: totalPacks,
        totalBox: totalBoxes,
        totalKilos: totalKilo,
        totalEach: totalEs,
        totalValue: totalVal,
      };
    }
  },
};

const actions = {
  async fetchExistingOrders({ commit }, load) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      customerNo: this.getters.retrieveSelectedCustomer,
      daysPast: `${load ? load.daysPast : 90}`,
      locked: null,
    };
    console.log(payload);
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios2.post("order/get-orders", params);

    if (response.data.success == true) {
      commit("setOrders", response.data.orders);
      return response.data.success;
    } else {
      response.data.success;
    }
  },

  async fetchOrdersProducts({ commit }, load) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      tddid: load.tdId,
    };
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios2.post("order/get-order-prods", params);

    if (response.data.success == true) {
      commit("setOrderProducts", response.data.products);
      return response.data.success;
    } else {
      response.data.success;
    }
  },

  fetchOrderTickets(context, payload) {
    // commit('setOrderTickets',Object.keys(payload.order.tickets))
    context.commit("setOrderTickets", Object.values(payload.tickets));
    //console.log(context)
  },

  async sendEmail({}, id) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      tdId: id,
    };
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("resend-email", params);
    return response.data;
  },

  async voidOrder({}, id) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      tdId: id,
    };
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("void-order", params);
    return response.data;
  },

  clearOrderTickets({ commit }) {
    commit("setOrderTickets", []);
  },
  clearOrders({ commit }) {
    commit("setOrders", []);
  },

  clearOrderProducts({ commit }) {
    commit("setOrderProducts", []);
  },
};

const mutations = {
  //Assign the object we got from the API to be our customer
  setOrders: (state, orders) => (state.orders = orders),
  setOrderProducts: (state, products) => (state.orderProducts = products),
  setOrderTickets: (state, tickets) => (state.orderTickets = tickets),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
